import { formatPrice, formatDateString } from '@lib/utils';
import getLayerStore from '@stores/LayerStore';
import { PropertyHighlight, PropertyImage, PropertyInfoContainer } from './style';

import type React from 'react';

const LayerStore = getLayerStore();

type Props = {
  address: string;
  highlights: string[];
  price: number;
  priceSqM: number;
  onlineSince: string;
  img?: string;
};

export const PropertyInfo: React.FC<Props> = ({
  address,
  highlights,
  price,
  priceSqM,
  onlineSince,
  img,
}: Props) => {
  const handleCTAClick = (): void => {
    LayerStore.setVisibilityWidgetX(true);
  };

  return (
    <PropertyInfoContainer key={address}>
      {img && <PropertyImage src={img} />}
      <p className="bold">{address}</p>
      <ul>
        {highlights.map((highlight) => (
          <PropertyHighlight key={highlight}>{highlight}</PropertyHighlight>
        ))}
      </ul>
      <div className="date-info">
        <p>Zeitpunkt des Preises: {formatDateString(onlineSince, true)}</p>
      </div>
      <div className="prices-container">
        <p className="bold">{formatPrice(price)} €</p>
        <p>{formatPrice(priceSqM)} €/m²</p>
      </div>
      <button onClick={handleCTAClick} className="CTA">
        Jetzt Bewertung anfordern
      </button>
    </PropertyInfoContainer>
  );
};
